import mykhailoPhoto from "@assets/image_1773345523383.png";
import rabonaHomepage from "@assets/Screenshot_2026-03-22_232606_1774218566131.png";
import rabonaRegistrace from "@assets/Screenshot_2026-03-22_232623_1774218566131.png";
import rabonaHry from "@assets/Screenshot_2026-03-22_232647_1774218566132.png";
import rabonaPromoakce from "@assets/Screenshot_2026-03-22_232714_1774218566132.png";
import rabonaPodpora from "@assets/Screenshot_2026-03-22_232735_1774218566132.png";
import rabonaVklad from "@assets/Screenshot_2026-03-22_232814_1774218566133.png";
import rabonaVyber from "@assets/Screenshot_2026-03-22_232851_1774218566133.png";
import { useSEO } from "@/hooks/use-seo";
import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Trophy, Zap, Smartphone
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo7 from "@assets/logos_extracted/7.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://rbn.fynkelto.com/?mid=279656_1645828";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const depositMethods = [
  "PlayID", "Mastercard", "Paysafecard", "Skrill", "Nuvei",
  "Neteller", "Jetonbank", "MiFinity", "USDT TRC20", "USDT ERC20",
  "USDT BEP20", "Bitcoin", "Ethereum", "Litecoin", "Solana",
  "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "PlayID", "Visa", "Mastercard", "Bank Transfer", "Revolut",
  "Skrill", "Nuvei", "Neteller", "Jetonbank", "MiFinity",
  "USDT TRC20", "USDT ERC20", "USDT BEP20", "Bitcoin", "Ethereum",
  "Litecoin", "Solana", "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const providers = "1X2 Gaming, 3 Oaks Gaming, 7777 Gaming, All41 Studios, Amatic Industries, Amusnet (EGT), Apollo Games, Arcade, Atmosfera, Belatra Games, Betsoft, Betsolutions, BF Games, BGaming, Bombay Live, Booming Games, Big Time Gaming, Caleta Gaming, Casino Technology, Claw, ELA Games, ELK Studios, Endorphina, Evolution Gaming, Evoplay Entertainment, Ezugi, Felix Gaming, Felt, Foxium, Fugaso, G.Games, Gamebeat, Gameburger Studios, Gaming Corps, Gaming Realms, Gamomat, Gamzix, Golden Rock Studios, Habanero, Hacksaw Gaming, High 5 Games, InBet Games, InOut, IronDog, JFTW, KA Gaming, Kalamba Games, Kiron Interactive, Leap Gaming, Lucky Streak, Mascot Gaming, Mercury, Microgaming, NetEnt, NetGaming, Nolimit City, Novomatic, Nucleus Gaming, Octoplay, OnAir, OneTouch, Onlyplay, Oryx, Platipus, Play\u2019n GO, PlayPearls, Playson, Playtech, Pocket Games Soft, Pragmatic Play, Pragmatic Play Live, Quickspin, Real Dealer Studios, Red Rake Gaming, Red Tiger Gaming, Relax Gaming, Revolver Gaming, Rogue Gaming, Ruby Play, Salsa Technology, Slotmill, Smartsoft Gaming, Spinmatic, Spinomenal, Spribe, StakeLogic, Stormcraft Studios, Swintt, Switch Studios, Thunderkick, Tom Horn Gaming, Triple Edge Studios, Turbo Games, Vibra Gaming, Wazdan, Woohoo, Yggdrasil, Zillion, LEMON";

const pros = [
  "Štědré bonusy – uvítací balíček, pravidelné promo akce, cashback, turnaje",
  "Široká nabídka platebních metod",
  "Rozvinutá sportovní sekce vhodná pro sportovní sázení",
  "Velký výběr automatů, živé kasino a dalších hazardních her",
  "Pohodlné mobilní rozhraní a aplikace – je to klíčové pro hráče, kteří chtějí hrát kdykoliv a kdekoliv",
  "Spolehlivá ochrana dat – je to zásadní pro bezpečnost a důvěru uživatelů",
  "Rabona Casino získalo pozitivní zpětnou vazbu od tisíců hráčů, což přispívá k jeho pověsti spolehlivého online kasina",
  "Rabona Casino má vysoké bezpečnostní skóre 8,9, což ukazuje na silný důraz na bezpečnost a férovost",
];

const cons = [
  "Limity na výběry – denní a měsíční stropy, i když pro většinu běžných hráčů jsou tyto limity dostačující",
  "Povinná verifikace účtu, i když tento proces zvyšuje bezpečnost a chrání hráče před podvodem",
  "Kasino není dostupné ve všech zemích, i když v podporovaných regionech nabízí plnohodnotné služby",
  "Zákaznická podpora není ve všech jazycích, i když v hlavních jazycích je dostupná a rychlá",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>280 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>280 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>do 1 hodiny (e-peněženky, krypto); 1–3 dny (karta)</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Žádné poplatky ze strany kasina</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <span className={valueClass}>PlayID, Mastercard, Paysafecard, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDT TRC20/ERC20/BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <span className={valueClass}>PlayID, Visa, Mastercard, Bank Transfer, Revolut, Skrill, Nuvei, Neteller, Jetonbank, MiFinity, USDT TRC20/ERC20/BEP20, Bitcoin, Ethereum, Litecoin, Solana, BNB, Ripple, Bitcoin Cash, Dogecoin, Cardano</span>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 14 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – vč. bonus-buy a jackpotů</span></div>
        <div className={rowClass}><span className={labelClass}>Živé stoly:</span><span className={valueClass}>Ano – Evolution a další</span></div>
        <div className={rowClass}><span className={labelClass}>Jackpotové hry:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Video poker:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Virtuální sporty:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Demo režim:</span><span className={valueClass}>Ano – u většiny her</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé:</span><span className={valueClass}>100+ výrobců softwaru vč. Evolution, Pragmatic Play, NetEnt, Play&apos;n GO</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@rabona.com</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://rabona.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">rabona.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2018</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Curaçao eGaming</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Angličtina, Němčina, Španělština, Finština, Francouzština, Maďarština, Norština, Polština, Italiana, Čeština a další</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Mobilní aplikace Android i iOS + responzivní web</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ano"],
      ["Limit sázek:", "Ano"],
      ["Limit ztrát:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ano"],
      ["Ověření účtu (KYC):", "Povinné při výběru"],
      ["Demo režim:", "Ano"],
      ["VIP program:", "Ano – 5 úrovní"],
    ];
    return (
      <div className="divide-y divide-[#eef1f7]">
        {items.map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={`${valueClass} ${value === "Ano" ? "text-green-600" : value === "Ne" ? "text-gray-400" : "text-gray-900"}`}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function RabonaPage() {
  useSEO({ title: "Rabona Casino Recenze 2026 – Sport, kasino a bonus | HrajBonus", description: "Recenze Rabona Casino. Sportovní sázení i kasino hry pod jednou střechou. Uvítací bonus, stovky slotů a live přenosy zápasů. 18+",
  url: "https://hrajbonus.com/kasina/rabona", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo7} alt="Rabona logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Rabona</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <Star className="w-5 h-5 fill-[#f5c518]/60 text-[#f5c518]" />
                  </div>
                  <span className="text-white font-bold text-xl">8.1</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "14 000+" },
                    { label: "Minimální vklad", value: "280 Kč" },
                    { label: "Minimální výběr", value: "280 Kč" },
                    { label: "Licence",         value: "Curaçao eGaming" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Rabona" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">8.1</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Rabona Casino nabízí férové a bezpečné prostředí pro hráče v Česku. Na trhu působí už od roku 2018 a za tu dobu si získalo důvěru díky široké nabídce automatů, živého kasina i sázkové kanceláře. O vaši bezpečnost se stará mezinárodní licence Curaçao eGaming. Díky podpoře českých platebních metod a lokalizovanému rozhraní je Rabona snadno dostupná hráčům z celé České republiky.
                </p>
                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-4">
                  <img src={rabonaHomepage} alt="Rabona Casino recenze 2026 – pohled na hlavní stránku s nabídkou sportovního sázení a live kasina" className="w-full h-auto object-cover" loading="lazy" />
                  <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Rabona Casino – hlavní stránka se sportovní nabídkou a live sázkami</div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Why beginners & experts like it */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Proč si Rabona oblíbí začátečníci i zkušení hráči</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rabona je skvělým místem pro ty, kdo teprve začínají s online hraním. Jednoduchá registrace, intuitivní rozhraní a možnost hrát už od 0,25 Kč za spin umožňuje vstoupit do světa hazardních her a automatů bez stresu. V nabídce najdete široký výběr her a bonusových možností, včetně demo režimu pro většinu her, což umožňuje hráčům vyzkoušet si hry bez rizika. Díky reálnému prostředí živého kasina se přiblížíte atmosféře kamenných provozoven.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Zkušení hráči zde najdou mnoho zajímavých funkcí: VIP stoly s vysokými limity, cashback, osobní nabídky, turnaje. Pro ty, kdo chtějí mít hru pod kontrolou, jsou k dispozici rozšířená nastavení sázení. Uživatelské rozhraní nabízí solidní uživatelský zážitek s moderním designem a plynulými přechody mezi sekcemi. Informace o zákaznické podpoře, bonusech a dalších důležitých údajích jsou snadno dostupné, což přispívá k celkové přehlednosti a důvěryhodnosti kasina.
                </p>
              </div>

              {/* Registration */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak se registrovat v Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-4">Registrace je snadná. Postupujte podle těchto kroků:</p>
                <div className="space-y-2.5 mb-4">
                  {[
                    "Navštivte oficiální web.",
                    "Klikněte na \u201eRegistrace\u201c.",
                    "Vyberte si uvítací bonus.",
                    "Zadejte osobní údaje a vyplňte formulář.",
                    "Potvrďte registraci.",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                    </div>
                  ))}
                </div>
                <div className="mt-5 flex gap-4 items-start bg-[#f3f6fb] rounded-xl p-4">
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-gray-900 text-sm mb-2">Tip při registraci</div>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      Při registraci si rovnou zvolte casino bonus – po přihlášení ho změnit nelze. Ujistěte se, že zadáváte správný e-mail, na který dostanete potvrzovací odkaz.
                    </p>
                  </div>
                  <div className="flex-shrink-0 w-[200px] rounded-lg overflow-hidden border border-[#dde4ee] shadow-sm">
                    <img src={rabonaRegistrace} alt="Rabona Casino – registrační formulář pro nové hráče, krok 1 ze 2" className="w-full h-auto object-cover" loading="lazy" />
                    <div className="bg-[#f7f9fd] px-2 py-1 text-[10px] text-gray-500 text-center leading-snug">Registrační formulář (krok 1/2)</div>
                  </div>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mt-3">
                  Ověření účtu po registraci není povinné, ale při prvním výběru je nutné.
                </p>
              </div>

              {/* Games */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jaké hazardní hry Rabona nabízí?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rabona má široký herní katalog s více než 14 000+ tituly a nabízí hry od více než 120 poskytovatelů.
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    "Výherní automaty",
                    "Stolní hry",
                    "Živé kasino",
                    "Hry s bonusovou koupí a jackpoty",
                    "Virtuální sporty a mini hry",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  Většina her je dostupná v demo režimu.
                </p>

                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={rabonaHry} alt="Rabona Casino – herní katalog s výběrem nových slotů od více než 120 poskytovatelů" className="w-full h-auto object-cover" loading="lazy" />
                  <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Rabona Casino – výběr nových slotů v herním katalogu</div>
                </div>

                <div className="mt-5 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Grafika a uživatelský zážitek</div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    Rozhraní Rabona zaujme tmavým designem s červenými a žlutými akcenty. Moderní vzhled a přehledná struktura usnadňují orientaci. Přechody mezi sekcemi jsou plynulé a grafika automatů je ostrá. Web je plně responzivní a cookies pomáhají personalizovat uživatelský zážitek.
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Rabona má intuitivní navigaci vhodnou pro všechny hráče: rychlé hledání her podle názvu, sekce jsou dostupné z kterékoliv stránky, mobilní rozhraní je plně přizpůsobené. Méně flexibilní filtrování podle poskytovatelů her je nevýhodou.
                  </p>
                </div>
              </div>

              {/* Sports betting */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Sázkové kanceláře Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Sázkové kanceláře Rabona představují ideální volbu pro všechny, kteří chtějí spojit svět sportovního sázení a online kasina na jednom místě. Rabona casino nabízí hráčům širokou škálu možností, jak si užít sázení a hazardní hry – ať už preferujete fotbal, tenis, basketbal, nebo dáváte přednost hracím automatům a stolním hrám, vše je vám k dispozici 24/7 přímo na webových stránkách Rabona.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Pro nové hráče je připraven atraktivní uvítací bonus až do výše 12 500 Kč, který lze získat po prvním vkladu od 500 Kč. Rabona nabízí také pravidelné propagační akce, turnaje a soutěže, díky kterým můžete získat další bonusy a odměny. Bonusy a promo akce jsou navrženy tak, aby zvýšily váš herní zážitek a nabídly více šancí na výhru.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Sázkové kanceláře Rabona umožňují sázet na více než desítku sportů, včetně populárních lig a živých událostí. Hráči mohou sázet nejen na sportovní zápasy, ale také na hazardní hry, jako jsou kasinové hry, hrací automaty nebo živé stolní hry. Díky tomu Rabona spojuje svět sázení a online kasina do jedné přehledné platformy.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Velkou výhodou je široká škála platebních metod – Rabona podporuje více než 15 způsobů vkladu a výběru, včetně platebních karet, bankovních převodů a online peněženek. Všechny transakce jsou bezpečné a rychlé, což potvrzují i pozitivní Rabona recenze od hráčů. Zákaznická podpora je k dispozici prostřednictvím live chatu a e-mailu (support@rabona.com), takže v případě dotazů nebo problémů se vždy můžete obrátit na profesionální tým.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Pro maximální pohodlí je k dispozici také mobilní aplikace Rabona pro Android i iOS, která nabízí všechny funkce webové stránky. Hráči tak mají přístup k sázení a hazardním hrám kdykoliv a odkudkoliv, ať už jsou doma, nebo na cestách.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Sázkové kanceláře Rabona jsou bezpečné a důvěryhodné, s důrazem na ochranu hráčů a férové podmínky. Díky široké nabídce sázek, atraktivnímu uvítacímu bonusu, rychlým a bezpečným platebním metodám a kvalitní zákaznické podpoře patří Rabona mezi nejlepší možnosti na trhu online kasin a sázkových kanceláří. Pokud hledáte místo, kde si užijete sázení a hazardní hry naplno, Rabona je tou správnou volbou.
                </p>
              </div>

              {/* Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hraní na mobilu v Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Mobilní aplikace Rabona pro Android i iOS nabízí všechny funkce webu.
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-4">
                  {[
                    { q: "Padá aplikace často?", a: "Ne" },
                    { q: "Je třeba často aktualizovat?", a: "Ne" },
                    { q: "Zážitek z mobilu je lepší?", a: "Ano" },
                    { q: "Ovládání uzpůsobené pro palec?", a: "Ano" },
                    { q: "Nutnost stahování softwaru?", a: "Ano" },
                    { q: "Kopie webu pro stolní počítače?", a: "Ano" },
                    { q: "Použitá technologie?", a: "HTML5" },
                  ].map(({ q, a }) => (
                    <div key={q} className="flex items-center justify-between gap-2 py-2 border-b border-[#eef1f7] last:border-0">
                      <span className="text-gray-600 text-xs">{q}</span>
                      <span className={`text-xs font-bold flex-shrink-0 ${a === "Ano" ? "text-green-600" : a === "Ne" ? "text-gray-400" : "text-[#003da5]"}`}>{a}</span>
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm leading-relaxed">
                  Aplikace je spolehlivá a adaptivní na různé obrazovky. Webové stránky Rabona Casino jsou plně responzivní a snadno ovladatelné jak na desktopu, tak na mobilních zařízeních, což výrazně zlepšuje uživatelský zážitek.
                </p>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a promo akce Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Na webu Rabona jsou pravidelně dostupné atraktivní bonusy.
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {["Uvítací balíčky", "Cashback", "Free spiny", "Turnaje a soutěže", "VIP program", "Speciální akce ke sportovním událostem"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <Trophy className="w-4 h-4 text-[#c9960f] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  Pro všechny aktuální bonusy a promo akce podívejte se na web Rabona Casino nebo se přihlaste k odběru newsletteru, abyste měli vždy nejnovější informace.
                </p>
                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={rabonaPromoakce} alt="Rabona Casino – přehled aktuálních bonusů a promoakcí pro české hráče" className="w-full h-auto object-cover" loading="lazy" />
                  <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Rabona Casino – přehled aktuálních promoakcí (casino bonusy)</div>
                </div>
                <h3 className="font-bold text-gray-900 text-base mb-3">Co nabízí uvítací bonus Rabona?</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Každý nový hráč získá po registraci uvítací bonus.
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    "100 % až do 2 500 Kč na sportovní sázky",
                    "100 % až do 12 500 Kč, 200 free spinů a 1 Bonus Crab pro casino",
                    "Bonus přes promokód",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">
                  Pro casino bonus je potřeba první vklad od 500 Kč. Peníze jsou připsány okamžitě, free spiny jsou rozděleny do 10 dní. Peněžní bonus je třeba protočit 35×, výhry z free spinů 40×.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak získat uvítací bonus Rabona?</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Přejděte na oficiální web kasina.",
                      "Klikněte na \u201eRegistrace\u201c.",
                      "Zvolte casino bonus.",
                      "Vložte minimálně 500 Kč.",
                      "Bonus se připočte automaticky.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                  <p className="text-gray-500 text-xs mt-3">Na rozdíl od jiných sázkových kanceláří, Rabona nabízí bonusy jasně a transparentně.</p>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <p className="text-gray-700 text-sm leading-relaxed">
                    <span className="font-bold text-[#003da5]">Rabona bonus bez vkladu</span> – Aktuálně Rabona nenabízí žádný aktivní bonus bez vkladu. Tyto nabídky se ale mohou objevit v rámci speciálních promo akcí. Pro uvítací bonus kód nepotřebujete – Rabona nabízí akce i bez kódů.
                  </p>
                </div>

                {/* Comparison table */}
                <h3 className="font-bold text-gray-900 text-base mb-3">Podobné nabídky dalších kasin</h3>
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Kasino</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Bonus za první vklad</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Min. vklad</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Wager</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Free Spiny</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Rabona", "100% do 12 500 Kč", "500 Kč", "x35 (x40 FS)", "200"],
                        ["Casinia", "100% do 12 500 Kč", "500 Kč", "x35 (x40 FS)", "200"],
                        ["Instant", "100% do 10 000 Kč", "500 Kč", "x40", "100"],
                        ["Librabet", "100% do 12 500 Kč", "500 Kč", "x35 (x40 FS)", "200"],
                        ["Buran", "100% do 21 000 Kč", "500 Kč", "x40", "200"],
                      ].map(([casino, bonus, min, wager, fs], i) => (
                        <tr key={i} className={`border-t border-[#eef1f7] ${i === 0 ? "bg-[#f0f5ff]" : ""}`}>
                          <td className="px-4 py-2.5 font-medium text-gray-900 text-xs">{casino}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{bonus}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{min}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{wager}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{fs}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-500 text-xs mt-2">Tato kasina poskytují podobné struktury bonusů s odlišným herním portfoliem.</p>
              </div>

              {/* VIP */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Věrnostní program Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rabona odměňuje aktivní hráče pomocí 5-úrovňového VIP programu. Nabízí:
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-4">
                  {[
                    "Osobního manažera",
                    "Týdenní cashback až 15 %",
                    "Vyšší limity na výběr",
                    "Exkluzivní bonusy",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm">Program osloví hráče, kteří hledají tipy a strategie pro efektivnější sázení.</p>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody Rabona</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rabona zajišťuje jednoduché, rychlé a bezpečné platby. Nabízí širokou škálu platebních metod pro vklady i výběry – celkem 33 platebních metod, včetně platebních karet, bankovních převodů, předplacených karet a populárních e-peněženek jako Neteller, Skrill a PaysafeCard. Všechny transakce jsou zpracovávány rychle a bezpečně, chráněny SSL šifrováním.
                </p>
                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {[
                    "Více než 15 možností vkladu",
                    "Přes 10 způsobů výběru",
                    "Podpora různých měn včetně Kč",
                    "Výběr do 1–24 hodin",
                    "Bez poplatků",
                    "Transakce chráněny SSL šifrováním",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button onClick={() => setShowAllDeposit(!showAllDeposit)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button onClick={() => setShowAllWithdrawal(!showAllWithdrawal)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                {/* Payment speed table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Platební metoda</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Min. vklad/výběr (Kč)</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Vklad</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Výběr</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["Visa/Mastercard", "280 / 280", "Okamžitě", "1–3 dny"],
                        ["JetonBank", "280 / 280", "Okamžitě", "do 1 h"],
                        ["MiFinity", "300 / 300", "Okamžitě", "do 1 h"],
                        ["Skrill", "280 / 280", "Okamžitě", "do 1 h"],
                        ["Neteller", "280 / 280", "Okamžitě", "do 1 h"],
                        ["Bitcoin", "750 / 100", "Okamžitě", "do 1 h"],
                        ["Kryptoměny", "280 / 100", "Okamžitě", "do 1 h"],
                        ["FunID", "280 / 500", "Okamžitě", "do 1 h"],
                      ].map(([method, min, dep, wdl], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-medium text-gray-900 text-xs">{method}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{min}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{dep}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{wdl}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-500 text-xs mt-2">Všechny transakce jsou bez poplatků, ale vyžadují ověření účtu.</p>

                <div className="grid sm:grid-cols-2 gap-3 mt-5">
                  <div className="rounded-xl overflow-hidden border border-[#dde4ee]">
                    <img src={rabonaVklad} alt="Rabona Casino – dostupné metody vkladu a minimální limity v Kč" className="w-full h-auto object-cover" loading="lazy" />
                    <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Vkladové metody a limity</div>
                  </div>
                  <div className="rounded-xl overflow-hidden border border-[#dde4ee]">
                    <img src={rabonaVyber} alt="Rabona Casino – dostupné metody výběru peněz a minimální limity v Kč" className="w-full h-auto object-cover" loading="lazy" />
                    <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Metody výběru a limity</div>
                  </div>
                </div>

                <div className="mt-5 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak vložit peníze v Rabona?</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Přihlaste se do účtu.",
                      "Klikněte na \u201ePokladna\u201c, pak \u201eVklad\u201c.",
                      "Vyberte metodu.",
                      "Zadejte částku, potvrďte platbu.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                  <p className="text-gray-500 text-xs mt-3">Vložení peněz je snadné a rychlé.</p>
                </div>
              </div>

              {/* Safety */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a licence</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rabona provozuje svou činnost na základě mezinárodní licence a klade silný důraz na bezpečnost hráčů. Doporučujeme hráčům, aby se na bezpečnostní opatření vždy zaměřili a ověřili si, zda kasino splňuje všechny důležité standardy. Rabona Casino je licencováno a regulováno renomovaným licenčním úřadem, což zajišťuje dodržování přísných provozních standardů. Všechna data a transakce jsou chráněny SSL šifrováním a kasino používá pokročilé šifrovací technologie k zabezpečení veškeré komunikace mezi hráči a kasinem.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Rabona Casino vyžaduje ověření identity při výběrech v rámci politiky KYC, což přispívá k ochraně hráčů. Pro podporu zodpovědného hraní jsou nastaveny limity vkladů, sázek a ztrát a hráči mají možnost sebevyloučení, pokud si chtějí dát pauzu od hraní. Rabona Casino má vysoké bezpečnostní skóre 8,9, což značí bezpečné a férové prostředí. Navíc není uvedeno na žádných významných blacklistech, což naznačuje férový a transparentní provoz.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Mezinárodní licence Curaçao eGaming",
                    "SSL šifrování všech transakcí",
                    "Ověření identity pro výběry (KYC)",
                    "Limity vkladů, sázek a ztrát",
                    "Možnost sebevyloučení",
                    "Demo režim pro hraní bez rizika",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Customer support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora 24/7</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Zákaznický servis Rabona Casino je známý svou rychlou a profesionální odpovědí. Zákaznickou podporu můžete kontaktovat 24/7 v češtině prostřednictvím live chatu i e-mailu. Operátoři zákaznické podpory Rabona Casino rychle reagují, jsou vstřícní a patří mezi zkušené a školené agenty.
                </p>
                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={rabonaPodpora} alt="Rabona Casino – centrum nápovědy se zákaznickou podporou dostupnou 24/7 přes live chat a e-mail" className="w-full h-auto object-cover" loading="lazy" />
                  <div className="bg-[#f7f9fd] px-3 py-1.5 text-xs text-gray-500 text-center">Rabona Casino – centrum nápovědy s live chatem a e-mailovou podporou 24/7</div>
                </div>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 dostupný</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@rabona.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Final pros/cons */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a nevýhody Rabona v kostce</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Conclusion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  Rabona je jedním z nejdéle fungujících kasin v naší recenzi – na trhu od roku 2018 – a za tuto dobu si získalo důvěru hráčů v České republice. Tato zkušenost se odráží v propracovaném herním portfoliu (14 000+ her a pestrých bonusů), silném VIP programu a přehledném rozhraní. Unikátní prvek sbírání fotbalových kartiček přidává hravý rozměr. Hodnocení 8,1 odráží solidní platformu, která si po léta buduje dobrou reputaci.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo7} alt="Rabona" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Rabona</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <Star className="w-3 h-3 fill-[#f5c518]/60 text-[#f5c518]" />
                        <span className="text-gray-600 text-xs ml-1">8.1/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe,      label: "Web",          value: "rabona.com" },
                      { icon: Calendar,   label: "Rok",          value: "2018" },
                      { icon: Lock,       label: "Licence",      value: "Curaçao eGaming" },
                      { icon: Users,      label: "Provozovatel", value: "Stellar Ltd" },
                      { icon: Gamepad2,   label: "Počet her",    value: "14 000+" },
                      { icon: Smartphone, label: "Mobilní app",  value: "Android & iOS" },
                      { icon: Clock,      label: "Podpora",      value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad",   value: "280 Kč" },
                      { icon: Zap,        label: "Výplaty",      value: "do 1 h (e-wallet/krypto)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="rabona" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/bankonbet" className="text-[#003da5] hover:underline" data-testid="review-link-bankonbet">Bankonbet</a>
              {" · "}
              <a href="/kasina/bassbet" className="text-[#003da5] hover:underline" data-testid="review-link-bassbet">Bassbet</a>
              {" · "}
              <a href="/kasina/sg-casino" className="text-[#003da5] hover:underline" data-testid="review-link-sg-casino">SG Casino</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
